/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { mixins, colors, fonts } from '@blend/consumer-components';

export namespace DeviceInputWrapper {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {
    label: string;
  }
}

const styles = StyleSheet.create({
  deviceInputWrapper: {
    width: '100%',
    border: `1px solid ${colors.catalystLight30}`,
    borderRadius: 4,
    ...mixins.margin(24, 'auto'),
  },
  innerWrapper: {
    ...mixins.padding(24, 16),
    textAlign: 'center',
    fontWeight: fonts.weight.medium,
    fontSize: 16,
  },
  deviceInfo: {
    width: '100%',
    ...mixins.margin(24, 0, 0, 0),
  },
  inputWrapper: {
    ...mixins.margin(16, 0, 0, 0),
  },
});

export const DeviceInputWrapper: React.FC<DeviceInputWrapper.Props> = ({ label, children }) => {
  return (
    <div className={css(styles.deviceInputWrapper)} data-dd-privacy="allow">
      <fieldset>
        <div className={css(styles.innerWrapper)}>
          {label}
          <div className={css(styles.deviceInfo)}>{children}</div>
        </div>
      </fieldset>
    </div>
  );
};
